export default "__VITE_ASSET__B3Sf57fi__"